import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconCaretDown } from '@wds/icons';
import { Menu } from '@wds/menu';

import PropTypes from 'prop-types';
import { STRINGS } from './constants';
import getComponentWithTheme from '../../../../../themeProvider';
import AdminNavigation from './AdminNavigation';
import ApplicantNavigation from './ApplicantNavigation';
import ReviewerNavigation from './ReviewerNavigation';
import RecommenderNavigation from './RecommenderNavigation';

const Navigation = (props) => {
	const {
		userDetails, userRole, languages, assumedRole, siteInfo, permissions, pages, currentLanguage, cdnUrl,
	} = props;
	const [language, setLanguage] = useState(currentLanguage);
	const ref = useRef(language);

	useEffect(() => {
		if (ref.current !== language) {
			window.location.href = `/lang/?lang=${language}`;
		}
	}, [language]);

	const navStyle = {
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		position: 'absolute',
		zIndex: 1032,
		height: assumedRole ? '96px' : '48px',
	};

	const subNavItemStyle = {
		padding: '0 1rem',
		height: '48px',
		backgroundColor: '#f8f8f8',
		width: '100%',
		position: 'relative',
		top: 48,
		zIndex: 1032,
		borderBottom: '1px solid #CACACA',
	};

	const subNav = { top: 46 };

	const handleClickOrg = (org) => {
		window.location.href = `/org/sw/?org_id=${org.id}`;
	};

	return (
		getComponentWithTheme(
			<Box element='nav' style={navStyle} role='region' aria-label='top bar'>
				{userRole === 'admin' && (
					<AdminNavigation
						userDetails={userDetails}
						userRole={userRole}
						languages={languages.site_languages}
						assumedRole={assumedRole}
						siteInfo={siteInfo}
						permissions={permissions}
						language={language}
						setLanguage={setLanguage}
						cdnUrl={cdnUrl}
					/>
				)}
				{(userRole === 'applicant' || userRole === '') && (
					<ApplicantNavigation
						userDetails={userDetails}
						userRole={userRole}
						languages={languages.site_languages}
						assumedRole={assumedRole}
						siteInfo={siteInfo}
						permissions={permissions}
						pages={pages}
						language={language}
						setLanguage={setLanguage}
						cdnUrl={cdnUrl}
					/>
				)}
				{userRole === 'reviewer' && (
					<ReviewerNavigation
						userDetails={userDetails}
						userRole={userRole}
						languages={languages.site_languages}
						assumedRole={assumedRole}
						siteInfo={siteInfo}
						permissions={permissions}
						pages={pages}
						language={language}
						setLanguage={setLanguage}
						cdnUrl={cdnUrl}
					/>
				)}
				{userRole === 'recommender' && (
					<RecommenderNavigation
						userDetails={userDetails}
						userRole={userRole}
						languages={languages.site_languages}
						assumedRole={assumedRole}
						siteInfo={siteInfo}
						permissions={permissions}
						pages={pages}
						language={language}
						setLanguage={setLanguage}
						cdnUrl={cdnUrl}
					/>
				)}
				{(assumedRole || (siteInfo.isOrgSite && userDetails?.organizations?.length > 0)) && (
					<Box
						display='flex'
						flexDirection='column'
						style={subNav}
					>
						{siteInfo.isOrgSite && (userRole === 'applicant' || userRole === '') && userDetails?.organizations?.length > 0 && (
							<Box
								id='organization-sub-nav'
								display='flex'
								justifyContent='space-between'
								alignItems='center'
								style={{ ...subNavItemStyle, backgroundColor: '#ffffff' }}
							>
								<Menu
									menuTrigger={(
										<div>
											<Box display='flex'>
												<Typography>
													{userDetails.fullName}
													{' '}
													<IconCaretDown size='sm' />
												</Typography>
											</Box>
										</div>
									)}
								>
									{userDetails?.organizations?.map((org) => (
										<Menu.Item key={`org-${org.id}`} onClick={() => handleClickOrg(org)}>
											<i className='nc-icon-mini business_building' />
											{' '}
											{org.name}
										</Menu.Item>
									))}
								</Menu>
							</Box>
						)}
						{assumedRole && (
							<Box
								id='assumed-role-sub-nav'
								display='flex'
								justifyContent='space-between'
								alignItems='center'
								style={{ ...subNavItemStyle, zIndex: 1031 }}
							>
								<Box>
									<i className='nc-icon-mini arrows-1_tail-triangle-left mr-2' />
									<Typography
										component='a'
										href={assumedRole.return_url}
									>
										{STRINGS.returnToAdmin}
									</Typography>
								</Box>
								<Box>
									{STRINGS.loggedInAs}
									{' '}
									{userDetails.fullName}
								</Box>
							</Box>
						)}
					</Box>
				)}
			</Box>,
		));
};

Navigation.propTypes = {
	userDetails: PropTypes.object.isRequired,
	userRole: PropTypes.string.isRequired,
	languages: PropTypes.object.isRequired,
	assumedRole: PropTypes.object,
	siteInfo: PropTypes.object.isRequired,
	permissions: PropTypes.object,
	pages: PropTypes.array,
	currentLanguage: PropTypes.string.isRequired,
	cdnUrl: PropTypes.string.isRequired,
};
Navigation.defaultProps = {
	assumedRole: {},
	permissions: {},
	pages: [],
};
export default Navigation;
